import React, { useEffect, useState } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { useSelector } from "react-redux";
import Loader from "../components/Layout/Loader";
import ProductCard from "../components/Route/ProductCard/ProductCard";

const BestSellingPage = () => {
  const [data, setData] = useState([]);
  const { allProducts, isLoading } = useSelector((state) => state.products);

  useEffect(() => {
    if (Array.isArray(allProducts)) {
      const sorted = [...allProducts].sort((a, b) => b.sold_out - a.sold_out);
      setData(sorted);
    }
  }, [allProducts]);

  if (isLoading) return <Loader />;

  return (
    <div className="min-h-screen bg-white">
      <Header activeHeading={3} />

      {/* Page header */}
      <section className="bg-black py-12">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-xs uppercase tracking-[0.25em] text-accent-500 mb-2">Most Popular</p>
          <h1 className="text-3xl md:text-4xl font-bold text-white">Best Selling Products</h1>
        </div>
      </section>

      {/* Products grid */}
      <section className="max-w-7xl mx-auto px-4 py-12">
        {data.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-secondary-400 text-lg">No products found.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
            {data.map((product, index) => (
              <ProductCard data={product} key={index} />
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default BestSellingPage;
